export default "__VITE_ASSET__brtCplcL__"